function inArray(find: any, arr: any[]): boolean {
    return arr.includes(find);
}

// ----------------------------------------------------------------------------

export default inArray;
